
import { cloneElement, useMemo, useCallback } from "react"

const MultiselectTickerDropdown = ({value, multiple, tickers, children}) => {

    const getItem = useCallback((val) => tickers?.find(option => option.value === val),[tickers])

    const selected = useMemo(() => tickers ? value?.map(val => getItem(val)) : [],[value,getItem,tickers])

    return (
        cloneElement(children, { multiple, value:selected})
    )
}

export default MultiselectTickerDropdown